import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CITIES } from "@/data/content";

// Editorial marquee + intervention zones grid (with city banner images)
export default function Zones() {
  return (
    <section id="zones" data-testid="zones" className="py-24 md:py-32 bg-brand-mist">
      <div className="mb-16 select-none">
        <Marquee speed={40} gradient={false}>
          {CITIES.concat(CITIES).map((c, i) => (
            <span
              key={i}
              className="font-display font-semibold text-5xl md:text-7xl tracking-tight text-stroke mx-8"
            >
              {c.name}
              <span className="text-brand-gold mx-8">·</span>
            </span>
          ))}
        </Marquee>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-golddark">
              <span className="w-8 h-px bg-brand-gold" /> Zones d&apos;intervention
            </span>
            <h2 className="mt-5 font-display font-semibold text-4xl md:text-6xl tracking-tight text-brand-navy leading-[1.05]">
              Un serrurier près de chez vous
            </h2>
          </div>
          <p className="text-base text-slate-600 max-w-sm leading-relaxed">
            Nous intervenons dans tout le secteur de Marne-la-Vallée en
            Seine-et-Marne (77). Découvrez la page dédiée à votre commune.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CITIES.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 3) * 0.06}>
              <Link
                to={`/zone/${c.slug}`}
                data-testid={`zone-card-${c.slug}`}
                className="group block rounded-2xl overflow-hidden border border-brand-line bg-white hover:shadow-xl hover:shadow-brand-navy/10 hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
              >
                <div className="relative aspect-square overflow-hidden bg-brand-navy">
                  <img
                    src={`/villes/${c.slug}.jpg`}
                    alt={`Serrurier ${c.name}`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 flex items-center justify-between">
                  <div>
                    <h3 className="font-display font-medium text-xl tracking-tight text-brand-navy">
                      Serrurier {c.name}
                    </h3>
                    <div className="mt-1 flex items-center gap-2 text-xs uppercase tracking-[0.12em] text-slate-500 font-medium">
                      <MapPin className="w-3.5 h-3.5 text-brand-gold" />
                      {c.cp}
                      {c.primary && (
                        <span className="text-brand-golddark">· Priorité</span>
                      )}
                    </div>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-slate-300 group-hover:text-brand-navy group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-300" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
